<div class="container text-left">
  <mat-toolbar class="titulo">Ordens Cadastradas</mat-toolbar>

  <div class="container text-left">
    <form [formGroup]="form">
      <div class="row">
        <mat-form-field class="md-button-right col-5">
          <input maxlength="25" matInput mask="0000000-00.0000.0.00.0000" placeholder="Preencher com n&uacute;mero CNJ*"
            formControlName="nroProcesso">
          <button matSuffix class="float-left" (click)="buscarPorNroProcesso()" [disabled]="!form.valid"
            mat-raised-button> Buscar </button>
          <button matSuffix class="mx-2" (click)="limparBusca()" [disabled]="nroProcesso.value === ''"
            mat-stroked-button> Limpar </button>
          <mat-hint align="end">{{nroProcesso.value.length}} / 20</mat-hint>
          <mat-error *ngIf="nroProcesso.hasError('required')">
            N&uacute;mero CNJ é <strong>obrigat&oacute;rio</strong>
          </mat-error>
          <mat-error *ngIf="nroProcesso.hasError('minlength')">
            N&uacute;mero CNJ deve possuir 20 caracteres. Atual
            {{nroProcesso.value.length}} / 20.
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <div class="mat-elevation-z2">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
        <ng-container matColumnDef="nroProcesso">
          <th mat-header-cell *matHeaderCellDef> Nº Processo </th>
          <td mat-cell *matCellDef="let element"> {{element.nroProcesso | mask: '0000000-00.0000.0.00.0000'}} </td>
        </ng-container>

        <ng-container matColumnDef="tpOrdem">
          <th mat-header-cell *matHeaderCellDef> Tipo da ordem </th>
          <td mat-cell *matCellDef="let element"> {{element.tpOrdemFormatado}} </td>
        </ng-container>

        <ng-container matColumnDef="nroOrdem">
          <th mat-header-cell *matHeaderCellDef> Nº da ordem </th>
          <td mat-cell *matCellDef="let element"> {{element.nroOrdem}} </td>
        </ng-container>

        <ng-container matColumnDef="nomeServidor">
          <th mat-header-cell *matHeaderCellDef> Usuário </th>
          <td mat-cell *matCellDef="let element"> {{element.nomeServidor | uppercase}} </td>
        </ng-container>

        <ng-container matColumnDef="dtaAnotacao">
          <th mat-header-cell *matHeaderCellDef> Data de envio </th>
          <td mat-cell *matCellDef="let element"> {{element.dtaAnotacao | date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element" [style]="setStyleByStatus(element.statusFormatado)">
            {{ element.statusFormatado }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cartaResposta">
          <th mat-header-cell *matHeaderCellDef> Carta resposta </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.sistemaOrigem === 'SJ2'" >
              <button matSuffix (click)="getCartasIsFinalizado(element.id)" mat-raised-button>
                <img id="u653_img" src="../../../../assets/images/ordens_cadastradas/u653.png"> Download
              </button>
            </div>
            <div *ngIf="element.sistemaOrigem === 'SJ1' && element.arquivoOficioResposta !== null && element.arquivoOficioResposta !== ''  ">
              <button matSuffix (click)="getArquivoOficioResposta(element)" mat-raised-button>
                <img id="u653_img" src="../../../../assets/images/ordens_cadastradas/u653.png"> Download
              </button>
            </div>
            <div *ngIf="element.sistemaOrigem === 'SJ' && element.s !== null && element.statusFormatado == 'Finalizado'">
              <button matSuffix (click)="getCartaSolicitacao(element)" mat-raised-button>
                <img id="u653_img" src="../../../../assets/images/ordens_cadastradas/u653.png"> Download
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="detalhes">
          <th mat-header-cell *matHeaderCellDef> Detalhes </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="detalharOrdem(element)">
              <mat-icon>info</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="element-row"></tr>
      </table>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

    </div>
  </div>

</div>
